<template>
    <NuxtLink
        v-if="post?.id"
        :class="
            twMerge(
                'relative flex w-full gap-4 overflow-hidden lg:gap-10',
                type === 'next' && 'sm:flex-row-reverse',
            )
        "
        :to="$localePath(`/news/${post?.id}`)"
        v-sendGAsignal="{
            event_category: route.path.includes('news')
                ? `/news/${post?.id}`
                : `/awards/${post?.id}`,
            event_label: type === 'next' ? '下一則' : '上一則',
        }"
    >
        <div
            class="h-[104px] w-[104px] flex-shrink-0 overflow-hidden rounded-[20px] sm:h-[112px] sm:w-[112px] lg:h-[172px] lg:w-[172px]"
        >
            <img
                v-if="post?.featured_image"
                :src="post?.featured_image"
                :alt="post?.title"
                class="h-full w-full object-cover object-center"
            />
        </div>

        <div class="flex flex-col gap-4 lg:max-w-[440px]">
            <div
                :class="
                    twMerge(
                        'flex items-center gap-2 ',
                        type === 'next' && 'sm:justify-end',
                    )
                "
            >
                <SvgArrowBack20 v-if="type === 'prev'" class="!h-5 !w-5" />
                <p class="text-[1rem]/[1.4] font-bold">
                    {{
                        type === "prev"
                            ? t("news.post.navigation.previous")
                            : t("news.post.navigation.next")
                    }}
                </p>
                <SvgArrowForward20 v-if="type === 'next'" class="!h-5 !w-5" />
            </div>
            <AtomsH3 :class="{ 'sm:text-right': type === 'next' }">
                {{ post?.title }}
            </AtomsH3>
        </div>
    </NuxtLink>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { post, type } = defineProps({
    post: {
        type: Object,
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
});
const { t } = useI18n();
const route = useRoute();
</script>
